export default "__VITE_ASSET__CfZWJY5D__"